import React from 'react'
import { IoIosArrowBack } from 'react-icons/io'
import "./BackAlterButton.css"
const BackAlterButton = (props) => {
    
  return (
    // <div 
    // className={`back-btn ${props?.btnStyle}`}
    // onClick={props?.backHandler}
    // >
    //   <IoIosArrowBack className="back-icon" />
    //   <button
    //     // className={` ${props?.btnStyle}`}
    //   >
    //     {props?.btnName}
    //   </button>
    // </div>
    <div className="btn btn-primary btn-pill" onClick={props?.backHandler}>
      
    <i class="ti-arrow-left me-1"></i> {props?.btnName}
  </div>
  )
}

export default BackAlterButton